export default function Footer() {
  return (
    <div className="footer-wrap">
      <div className="site-footer container">
        <div className="wsite-elements wsite-footer">
          <div>
            <div className="wsite-multicol">
              <div className="wsite-multicol-table-wrap" style={{ margin: '0 -15px' }}>
                <table className="wsite-multicol-table">
                  <tbody className="wsite-multicol-tbody">
                    <tr className="wsite-multicol-tr">
                      <td className="wsite-multicol-col" style={{ width: '82.096474953618%', padding: '0 15px' }}>
                        <div style={{ textAlign: 'center' }}>
                          <div style={{ height: 0, overflow: 'hidden' }} />
                          <span className="wsite-social wsite-social-default">
                            <a className="first-child wsite-social-item wsite-social-facebook" href="https://www.facebook.com/RecyclaChile" target="_blank" rel="noreferrer" alt="Facebook" aria-label="Facebook">
                              <span className="wsite-social-item-inner" />
                            </a>
                            <a className="wsite-social-item wsite-social-linkedin" href="https://www.linkedin.com/company/recyclachile/" target="_blank" rel="noreferrer" alt="Linkedin" aria-label="Linkedin">
                              <span className="wsite-social-item-inner" />
                            </a>
                            <a className="wsite-social-item wsite-social-mail" href="mailto:info@recycla.cl" target="_blank" rel="noreferrer" alt="Mail" aria-label="Mail">
                              <span className="wsite-social-item-inner" />
                            </a>
                            <a className="last-child wsite-social-item wsite-social-youtube" href="https://www.youtube.com/results?search_query=recycla+chile" target="_blank" rel="noreferrer" alt="Youtube" aria-label="Youtube">
                              <span className="wsite-social-item-inner" />
                            </a>
                          </span>
                          <div style={{ height: 0, overflow: 'hidden' }} />
                        </div>

                        <div className="wsite-spacer" style={{ height: '18px' }} />

                        <div className="paragraph" style={{ textAlign: 'center' }}>
                          Planta Reciclaje: Volcán Lascar Poniente 761, Barrio Industrial Lo Boza, Pudahuel, Santiago.
                          <br />
                          Desde teléfono fijo: (56) 2 2949 3040 · Desde celular: (56) 9 9178 3804
                        </div>
                      </td>

                      <td className="wsite-multicol-col" style={{ width: '17.903525046382%', padding: '0 15px' }}>
                        <div>
                          <div className="wsite-image wsite-image-border-none" style={{ paddingTop: 10, paddingBottom: 10, marginLeft: 0, marginRight: 0, textAlign: 'left' }}>
                            <img src="/uploads/1/1/9/7/119720466/sello-footer_1_orig.png" alt="Imagen" style={{ width: 'auto', maxWidth: '100%' }} />
                            <div style={{ display: 'block', fontSize: '90%' }} />
                          </div>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <div>
              <div style={{ height: 0, overflow: 'hidden', width: '100%' }} />
              <hr className="styled-hr" style={{ width: '100%' }} />
              <div style={{ height: 10, overflow: 'hidden', width: '100%' }} />
            </div>

            <div className="paragraph" style={{ textAlign: 'center' }}>
              <font size="1">
                <font color="#5fa233">POLÍTICA DE PRIVACIDAD</font>
                <br />
                © COPYRIGHT 2018. TODOS LOS DERECHOS RESERVADOS
              </font>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
